function show1() {
  document.getElementById('div1').style.display = 'none';
}
function show2() {
  document.getElementById('div1').style.display = 'block';
}

function show3() {
document.getElementById('div2').style.display = 'none';
}
function show4() {
document.getElementById('div2').style.display = 'block';
}
